import config from 'BRAND/config';

const hasFeature = (store) => {
  return {
    inserted: function (el, binding, vnode) {
      const userAuthorities = store.getters.getUserAccount ? store.getters.getUserAccount.authorities : [];
      if (hasAuthorities(userAuthorities, binding.value)) {
        return;
      }
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  };
};

const hasAnyFeature = (store) => {
  return {
    inserted: function (el, binding, vnode) {
      const features = binding.value;
      const userAuthorities = store.getters.getUserAccount ? store.getters.getUserAccount.authorities : [];
      for (let feature of features) {
        if (hasAuthorities(userAuthorities, feature)) {
          return;
        }
      }
      vnode.elm.parentElement.removeChild(vnode.elm);
    }
  };
};

const hasAuthorities = (userAuthorities, feature) => {
  const featurePermission = config.featurePermission.find(obj => {
    return obj.feature === feature;
  });
  if (featurePermission && featurePermission.authorities && userAuthorities) {
    for (let authority of featurePermission.authorities) {
      for (let userAuth of userAuthorities) {
        if (authority === userAuth) {
          return true;
        }
      }
    }
  }
  return false;
};

export default {
  hasFeature,
  hasAnyFeature
};



// WEBPACK FOOTER //
// ./src/directives/featureToggleDirective.js